/**
 * Global instances of performance optimization classes
 */

import { BatchedUserFetcher } from './classes/BatchedUserFetcher.js';
import { LazyLoadManager } from './classes/LazyLoadManager.js';
import { SubscriptionManager } from './classes/SubscriptionManager.js';
import { CommentCache } from './classes/CommentCache.js';
import { RequestDeduplicator } from './classes/RequestDeduplicator.js';

// Global instances
export const batchedUserFetcher = new BatchedUserFetcher(null); // Will be initialized with dispatch
export const lazyLoadManager = new LazyLoadManager();
export const subscriptionManager = new SubscriptionManager();
export const commentCache = new CommentCache(200);
export const requestDeduplicator = new RequestDeduplicator();
